import { createTheme } from '@mui/material';
import "@fontsource/roboto-condensed";
import "@fontsource/roboto-condensed/900.css"
import "@fontsource/roboto-condensed/700.css";
import "@fontsource/roboto-condensed/500.css";
import "@fontsource/roboto-condensed/300.css";
import "@fontsource/roboto-condensed/100.css";


export const afcsBlue = '#365494';

export const theme = createTheme({
  spacing: 4,
  palette: {
    background: {
      default: afcsBlue
    },
    text: {
      primary: '#fff'
    }
  },
  typography: {
    fontFamily: "Roboto Condensed",
    body1: {
      fontSize: '1.2rem'
    },
    h1: {
      color: '#fff',
      textTransform: 'uppercase',
      fontWeight: 'bold',
      fontSize: '70px',
    },
    h2: {
      color: '#fff',
      textTransform: 'uppercase',
      fontWeight: 700,
      fontSize: '2.3rem'
    },
    h3: {
      color: '#fff',
      //textTransform: 'uppercase',
      fontSize: '1.2rem'
    }
  },
  components: {
    // MuiPaper: {
    //   styleOverrides: {
    //     root: {
    //       color: afcsBlue,
    //       padding: '10px 20px',
    //     }
    //   }
    // },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          maxWidth: '500px',
          padding: '10px 15px',
          p: {
            padding: '0',
            margin: '0',
          }
        }
      }
    },
    MuiListItemText: {
      styleOverrides: {
        secondary: {
          color: 'white',
          fontSize: '1rem',
          margin: '5px 15px'
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
          color: afcsBlue,
          // '&:hover': {
          //   color: '#FFD700'
          // }
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#0D1326',
          color: '#fff',
          '&:hover': {
            backgroundColor: '#1B2546',
          },
          // borderRadius: 0,
          '&.Mui-disabled': {
            color: 'rgba(255, 255, 255, 0.7) !important',
            backgroundColor: 'rgba(0, 0, 0, 0.5) !important'
          },
        },
        // disabled: {
        //   opacity: 1
        // }
      }
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          color: afcsBlue
        }
      }
    },
    MuiAccordionSummary: {
      styleOverrides: {
        expandIcon: {
          color: afcsBlue
        },
        root: {
          flexDirection: 'row-reverse', // Reorder the icon and the content
          '& .MuiAccordionSummary-expandIconWrapper': {
            marginRight: 1, // Adjust spacing between icon and text
            marginLeft: 0,
            color: afcsBlue
          },
          // position: 'sticky',
          // top: 0,
          // zIndex: 100,
          // backgroundColor: '#fff'
        }
      }
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          paddingTop: 0,
          paddingLeft: '15px'
        },
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: afcsBlue
          },
          '&:not(.Mui-checked)': {
            color: afcsBlue
          }
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          '& .MuiTypography-root.Mui-disabled': {
            color: afcsBlue,
          },
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#fff',
          color: afcsBlue,
          // margin: '10px 0px'
          boxShadow: 'inset 0 3px 5px rgba(0,0,0,0.2)',
          // '&.Mui-focused': {
          //   // border: '1px solid #868e96',
          //   boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)',
          // }
        },
        notchedOutline: {
          padding: '0 8px 0 12px',
        },
        // input: {
        //   padding: '8px',
        //   minHeight: 'auto',
        // }
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: ".9rem",
          color: "#eaeaea",
          marginTop: "9px",
          marginBottom: "4px",
          "&.Mui-error": {
            color: '#eaeaea',
          },
          "&.Mui-disabled": {
            color: '#eaeaea',
          }
        }
      }
    },
    MuiModal: {
      styleOverrides: {
        root: {
          color: afcsBlue,
          'h2': {
            color: afcsBlue,
          },
          'li': {
            marginBottom: '10px'
          }
        },
        typography: {
          h2: {
            color: afcsBlue,
          },
        }
      }
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          fontSize: '1rem'
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          '&.Mui-focused': {
            color: 'white',
          },
          // '&.Mui-disabled': {
          //   color: 'white'
          // }
        },
        shrink: {
          color: 'white',
          backgroundColor: 'black',
          borderColor: 'black',
          borderWidth: '1px',
          padding: '0 7px',
          borderRadius: '4px',
          '&.Mui-error': {
            color: 'white',
            backgroundColor: 'red',
            '& .MuiFormLabel-asterisk': {
              color: 'white'
            }
          },
          '&.Mui-disabled': {
            color: 'white'
          }
        }
      }
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          // '&.MuiAutocomplete-hasClearIcon .MuiInputLabel-outlined': {
          //   color: 'white',
          //   backgroundColor: 'black',
          //   padding: '0 6px',
          //   borderRadius: '4px'
          // }
        },
        option: {
          color: afcsBlue
        },
        tag: {
          color: afcsBlue,
          '& .MuiChip-deleteIcon': {
            color: '#fff',
            backgroundColor: afcsBlue,
            borderRadius: '50%',
          },
        },
        paper: {
          borderColor: 'black',
          borderWidth: '2px',
          borderStyle: 'solid',
        },
        listbox: {
          padding: 0,
        },
        // inputRoot: {
          // '&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child': {
          //   color: 'white',
          //   backgroundColor: 'black',
          //   padding: '0 6px',
          //   borderRadius: '4px'
          // }
        // }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          color: afcsBlue
        }
      }
    }
  }
});